import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  enabled: boolean;
  stickyOffset: number;
};

export const StickyAditionSlot = styled.div<Props>(
  ({enabled, stickyOffset}) =>
    enabled &&
    css`
      position: sticky;
      top: ${`${stickyOffset}px`};
      will-change: top;
      transition: top 200ms cubic-bezier(0.4, 0, 0.2, 1);
    `
);
